/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type for the search parameter used to query for VWB workspaces
 * @export
 */
export const VwbWorkspaceSearchParamType = {
    CREATOR: 'WORKSPACE_CREATOR',
    USER_FACING_ID: 'WORKSPACE_USER_FACING_ID',
    ID: 'WORKSPACE_ID',
    NAME: 'WORKSPACE_NAME',
    SHARED: 'WORKSPACE_SHARED',
    GCP_PROJECT_ID: 'WORKSPACE_GCP_PROJECT_ID'
} as const;
export type VwbWorkspaceSearchParamType = typeof VwbWorkspaceSearchParamType[keyof typeof VwbWorkspaceSearchParamType];


export function VwbWorkspaceSearchParamTypeFromJSON(json: any): VwbWorkspaceSearchParamType {
    return VwbWorkspaceSearchParamTypeFromJSONTyped(json, false);
}

export function VwbWorkspaceSearchParamTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbWorkspaceSearchParamType {
    return json as VwbWorkspaceSearchParamType;
}

export function VwbWorkspaceSearchParamTypeToJSON(value?: VwbWorkspaceSearchParamType | null): any {
    return value as any;
}

